import _ from 'lodash';
import { makeCell } from './gridUtill';
// import config from 'api/config';
import pdfIcon from '../../assets/img/icon_pdf.png';

let fields = [];
let columns = [];
const data = [
  {
    field: 'idx',
    alias: 'idx',
  },
  {
    field: 'lotNo',
    alias: 'Lot No',
  },
  {
    // 저장값은 원본 코드지만 화면에는 원산지 제한 접미사까지 붙은 표기값을 쓴다.
    // 정렬과 필터도 이 컬럼 기준으로 돌아간다.
    field: 'display_code',
    alias: 'Code Grade',
  },
  {
    field: 'pick_name',
    alias: '수령자',
  },
  {
    field: 'pickpart',
    alias: '수령업체명',
  },
  {
    field: 'request_date',
    alias: '요청일',
  },
  {
    field: 'produce_due_date',
    alias: '제조예정일',
  },
  {
    field: 'produce_date',
    alias: '제조완료일',
  },
  {
    field: 'out_due_date',
    alias: '출하예정일',
  },
  {
    field: 'out_date',
    alias: '출하완료일',
  },
  {
    field: 'delivery_date',
    alias: '납기일',
  },
  {
    field: 'stat_str',
    alias: '상태',
  },
  {
    field: 'coapdf_path',
    alias: 'COA',
    urlCallback: true,
    width: 50,
  },
  {
    field: 'coacode',
    alias: '발송상태',
    width: 100,
  },
  {
    field: 'msdspdf_path',
    alias: 'MSDS',
    urlCallback: true,
    width: 50,
  },
  {
    field: 'msdscode',
    alias: '발송상태',
    width: 100,
  },
  {
    // LOC 은 발송(메일) 없음 → 발행문서 아이콘 컬럼만, 발송상태 컬럼 없음. MSDS 와 동일 width:50
    // ※ locpdf_path1 은 RealGrid.vue commonSetFitLayout 의 자동폭조절 스킵목록에 추가되어 있어야 50px 유지됨
    field: 'locpdf_path',
    alias: 'LOC',
    urlCallback: true,
    width: 50,
  },
];
_.each(data, function (o) {
  o.indexExclusive = true;

  if (o.urlCallback) {
    makeCell(1, [o], fields, columns, null, null, {
      type: 'html',
      callback: function (grid, cell) {
        if (cell.valueColumn.fieldName && cell.valueColumn.fieldName === 'coapdf_path') {
          if (cell.value == undefined || cell.value == '') {
            return `<a href="#"></a>`;
          } else {
            let pdfPaths = cell.value.split(',');
            let pdfIcons = `<div class="icons">`;
            let nonEmptyPdfPaths = pdfPaths.filter(path => path.trim() !== '');
            if (nonEmptyPdfPaths.length > 0) {
              pdfIcons += `<img src="${pdfIcon}" alt="pdf icon" />`;
              if (nonEmptyPdfPaths.length > 1) {
                pdfIcons += `<span class="icon_num">` + nonEmptyPdfPaths.length + `</span>`;
              }
            }
            pdfIcons += `</div>`;
            return pdfIcons;
            // return `<div class="icons"><img src="${pdfIcon}" alt="pdf icon" /></div>`;
          }
        } else if (cell.valueColumn.fieldName && cell.valueColumn.fieldName === 'msdspdf_path') {
          if (cell.value == undefined || cell.value == '') {
            return `<a href="#"></a>`;
          } else {
            let pdfPaths = cell.value.split(',');

            let pdfIcons = `<div class="icons">`;

            // 아이콘 파일로
            // pdfPaths.forEach((pdfPath, i)=>{
            //   if (pdfPath.trim() !== "") {
            //     pdfIcons += `<img src="${pdfIcon}" alt="pdf icon" />`;
            //   }
            // });

            // 아이콘 곱하기
            let nonEmptyPdfPaths = pdfPaths.filter(path => path.trim() !== '');
            if (nonEmptyPdfPaths.length > 0) {
              pdfIcons += `<img src="${pdfIcon}" alt="pdf icon" />`;
              if (nonEmptyPdfPaths.length > 1) {
                pdfIcons += `<span class="icon_num">` + nonEmptyPdfPaths.length + `</span>`;
              }
            }
            pdfIcons += `</div>`;
            return pdfIcons;
          }
        } else if (cell.valueColumn.fieldName && cell.valueColumn.fieldName === 'locpdf_path') {
          if (cell.value == undefined || cell.value == '') {
            return `<a href="#"></a>`;
          } else {
            let pdfPaths = cell.value.split(',');
            let pdfIcons = `<div class="icons">`;
            let nonEmptyPdfPaths = pdfPaths.filter(path => path.trim() !== '');
            if (nonEmptyPdfPaths.length > 0) {
              pdfIcons += `<img src="${pdfIcon}" alt="pdf icon" />`;
              if (nonEmptyPdfPaths.length > 1) {
                pdfIcons += `<span class="icon_num">` + nonEmptyPdfPaths.length + `</span>`;
              }
            }
            pdfIcons += `</div>`;
            return pdfIcons;
          }
        }
      },
    });
  } else {
    makeCell(1, [o], fields, columns);
  }
});

// 자동생성(issued_document) 최신 MSDS id — 숨김 필드(컬럼 없음). 클릭 다운로드 분기용
fields.push({ fieldName: 'msds_issued_id', dataType: 'number' });
// 자동생성(issued_document) 최신 LOC id — 숨김 필드. 클릭 다운로드 분기용
fields.push({ fieldName: 'loc_issued_id', dataType: 'number' });

export { fields, columns };
